export default __webpack_public_path__ + "static/0023-1e75dc2796b91c4e2406e315beb703ff.png";